import { Category, Supabase } from '@firmable/contracts';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

export type State = {
  pageIndex: number;
  pageSize: number;
  selectedDownloadType: Supabase.Inngest.DownloadType | null;
  selectedCategory: Category | null;
  selectedStatus: Supabase.Inngest.DownloadStatus | null;
  requestIdFilter: string | null;
  userIdFilter: string | null;
};

export type Action = {
  setPageIndex: (pageIndex: number) => void;
  setPageSize: (pageSize: number) => void;
  setSelectedDownloadType: (type: Supabase.Inngest.DownloadType | null) => void;
  setSelectedCategory: (category: Category | null) => void;
  setSelectedStatus: (status: Supabase.Inngest.DownloadStatus | null) => void;
  setRequestIdFilter: (requestId: string | null) => void;
  setUserIdFilter: (userId: string | null) => void;
};

/**
 * Store to maintain state of download center list
 */
const useDownloadHistory = create<State & Action>()(
  devtools(
    immer((set) => ({
      pageIndex: 0,
      pageSize: 10,
      selectedDownloadType: null,
      selectedCategory: null,
      selectedStatus: null,
      requestIdFilter: null,
      userIdFilter: null,
      setPageIndex: (pageIndex: number) =>
        set(
          (state) => {
            state.pageIndex = pageIndex;
          },
          false,
          { type: 'setPageIndex' },
        ),
      setPageSize: (pageSize: number) =>
        set(
          (state) => {
            state.pageSize = pageSize;
          },
          false,
          { type: 'setPageSize' },
        ),
      setSelectedDownloadType: (type: Supabase.Inngest.DownloadType | null) =>
        set(
          (state) => {
            state.selectedDownloadType = type;
          },
          false,
          { type: 'setSelectedDownloadType' },
        ),
      setSelectedCategory: (category: Category | null) =>
        set(
          (state) => {
            state.selectedCategory = category;
          },
          false,
          { type: 'setSelectedCategory' },
        ),
      setSelectedStatus: (status: Supabase.Inngest.DownloadStatus | null) =>
        set(
          (state) => {
            state.selectedStatus = status;
          },
          false,
          { type: 'setSelectedStatus' },
        ),
      setRequestIdFilter: (requestId: string | null) =>
        set(
          (state) => {
            state.requestIdFilter = requestId;
          },
          false,
          { type: 'setRequestIdFilter' },
        ),
      setUserIdFilter: (userId: string | null) =>
        set(
          (state) => {
            state.userIdFilter = userId;
          },
          false,
          { type: 'setUserIdFilter' },
        ),
    })),
    {
      store: 'DownloadCenterListRecords',
    },
  ),
);

export { useDownloadHistory };
